import { Container, Heading, Panel } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'

import { AppHeader } from '@/components/AppHeader'
import { BackButton, CloseButton } from '@/components/icon-buttons/IconButtons'
import { Main } from '@/components/Main'
import { Page } from '@/components/Page'
import { PageHeading } from '@/components/PageHeading'
import StoreService from '@/store/StoreService'

import { JumbotronDefaultVideoMusic } from './JumbotronDefaultVideoMusic'
import { JumbotronDefaultVideoTrivia } from './JumbotronDefaultVideoTrivia'

export const JumbotronDefaultVideoRoute = observer(() => {
  const { currentGame } = StoreService.getStore()
  const history = useHistory()

  if (
    !currentGame ||
    (currentGame.gameData.type !== 'music' && currentGame.gameData.type !== 'trivia')
  ) {
    return (
      <Page title='Jumbotron Videos'>
        <AppHeader
          actionsLeft={<BackButton onClick={() => history.goBack()} />}
          actionsRight={<CloseButton onClick={() => history.push('/game')} />}
          header={<PageHeading>Jumbotron Settings</PageHeading>}
        />
        <Main>
          <Container size='medium'>
            <Panel className='flex flex-col gap-6'>
              <Heading>Videos</Heading>
              <p>Video URL settings are not available for this game type.</p>
            </Panel>
          </Container>
        </Main>
      </Page>
    )
  }

  if (currentGame.gameData.type === 'music') {
    return <JumbotronDefaultVideoMusic />
  }

  if (currentGame.gameData.type === 'trivia') {
    return <JumbotronDefaultVideoTrivia />
  }

  return null
})
